import * as b from "react";
import { u as h } from "./index-Dn5fq5RO.js";
function a(r) {
  const [d, e] = b.useState(void 0);
  return h(() => {
    if (r) {
      e({ width: r.offsetWidth, height: r.offsetHeight });
      const f = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const n = i[0];
        let o, t;
        if ("borderBoxSize" in n) {
          const s = n.borderBoxSize, u = Array.isArray(s) ? s[0] : s;
          o = u.inlineSize, t = u.blockSize;
        } else
          o = r.offsetWidth, t = r.offsetHeight;
        e({ width: o, height: t });
      });
      return f.observe(r, { box: "border-box" }), () => f.unobserve(r);
    } else
      e(void 0);
  }, [r]), d;
}
export {
  a as u
};
